import styled from 'styled-components';

export const QuestionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(112px, 1fr));
  justify-items: flex-start;
  grid-gap: 0.5rem;

  margin-top: 1rem;
`;
